var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListViewToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "3 -4 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_221992",
    "data-name": "Path 221992",
    d: "M3.25,7.25a1,1,0,0,1,1-1H5.583a1,1,0,1,1,0,2H4.25A1,1,0,0,1,3.25,7.25Zm2.333,5.667H4.25a1,1,0,1,0,0,2H5.583a1,1,0,1,0,0-2Zm0,6.667H4.25a1,1,0,0,0,0,2H5.583a1,1,0,0,0,0-2Zm3-12.333a1,1,0,0,1,1-1H24.25a1,1,0,0,1,0,2H9.583A1,1,0,0,1,8.583,7.25ZM24.25,12.917H9.583a1,1,0,1,0,0,2H24.25a1,1,0,0,0,0-2Zm0,6.667H9.583a1,1,0,0,0,0,2H24.25a1,1,0,0,0,0-2Z",
    transform: "translate(-3.25 -6.25)",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewToggle);
export default __webpack_public_path__ + "static/media/listViewToggle.0025504c5007ba33920e269b7295e68a.svg";
export { ForwardRef as ReactComponent };